<template>
    <TheGuidelinesLayout v-if="guideline">
        <BaseSection>
            <template #title>
                <h2>Translations</h2>
            </template>

            <template #default>
                <BaseFileList
                    v-if="!pending"
                    :files="translations"
                />

                <content-placeholders v-if="pending">
                    <content-placeholders-text :lines="6" />
                </content-placeholders>

                <p v-if="(!translations || !translations.length) && !pending">
                    Sorry, this guideline does not have any translations available.
                </p>
            </template>
        </BaseSection>
    </TheGuidelinesLayout>
</template>

<script setup>
import GuidelineTranslationsQuery from '~/graphql/queries/guidelines/translations.graphql';

const props = defineProps({
    guideline: {
        type: Object,
        required: true,
        default: null
    }
});

const { activeSite } = useMultisite();
const { variables } = useCraftGraphql();

if (activeSite.value?.handle) {
    variables.site = activeSite.value?.handle;
}
if (props.guideline?.id) {
    variables.id = Number(props.guideline.id);
}

const response = await useLazyAsyncQuery({
    query: GuidelineTranslationsQuery,
    variables
});

const { data, pending } = response;

const translations = computed(() => {
    if (data?.value?.entry?.translations) {
        return data.value.entry.translations;
    }
    return null;
});



const seo = computed(() => {
    if (!props.guideline.seo) {
        return;
    }

    return useSeo(props.guideline?.seo, props.guideline);
});

// todo - guidelines are not yet available for multisite's
useHead({
    title: `Translations of the ${props.guideline.title} guideline - Uroweb`,
    meta: seo.value?.meta ?? null
});
</script>
